module.exports = __webpack_public_path__ + "static/media/sunday_times_cropped.18715111.webp";